import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

//import images
import logoDark from "../assets/images/logo-dark.png";
import logoLight from "../assets/images/logo-light.png";

//import Components
import LanguageDropdown from '../Components/Common/LanguageDropdown';
import ProfileDropdown from '../Components/Common/ProfileDropdown';
import LightDark from '../Components/Common/LightDark';

import { changeSidebarVisibility } from '../slices/thunks';
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from 'reselect';
import QrCodeModal from "../Components/Common/QrCodeModal";
import { useTranslation } from 'react-i18next';
import {authUserManager} from "../helpers/api_helper";

const Header = ({ onChangeLayoutMode, layoutModeType, headerClass }) => {
    const dispatch = useDispatch();
    const { eventId: paramEventId } = useParams();
    const eventId = authUserManager.getAdminEventId() ?? paramEventId;
    const logoLink = authUserManager.isClubAdmin() ? '/admin/event/' + eventId : '/event/' + eventId;
    const selectDashboardData = createSelector(
        (state) => state.Layout,
        (state) => ({
            sidebarVisibilitytype: state.sidebarVisibilitytype})
      );
    // Inside your component
    const {sidebarVisibilitytype} = useSelector(selectDashboardData);

    const selectEventDetails = createSelector(
        (state) => state.Event,
        (slice) => ({
            event: slice.event,
        })
    );
    const { event } = useSelector(selectEventDetails);
    const startAt = event?.startAt;
    const isAdmin = authUserManager.isAdmin();
    const isClubAdmin = authUserManager.isClubAdmin();
    const shouldShowQrCode = isAdmin || isClubAdmin || startAt;


    const [search, setSearch] = useState(false);
    const toogleSearch = () => {
        setSearch(!search);
    };

    const toogleMenuBtn = () => {
        var windowSize = document.documentElement.clientWidth;
        dispatch(changeSidebarVisibility("show"));

        if (windowSize > 767)
            document.querySelector(".hamburger-icon").classList.toggle('open');

        //For collapse horizontal menu
        if (document.documentElement.getAttribute('data-layout') === "horizontal") {
            document.body.classList.contains("menu") ? document.body.classList.remove("menu") : document.body.classList.add("menu");
        }

        //For collapse vertical and semibox menu
        if (sidebarVisibilitytype === "show" && (document.documentElement.getAttribute('data-layout') === "vertical" || document.documentElement.getAttribute('data-layout') === "semibox")) {
            if (windowSize < 1025 && windowSize > 767) {
                document.body.classList.remove('vertical-sidebar-enable');
                (document.documentElement.getAttribute('data-sidebar-size') === 'sm') ? document.documentElement.setAttribute('data-sidebar-size', '') : document.documentElement.setAttribute('data-sidebar-size', 'sm');
            } else if (windowSize > 1025) {
                document.body.classList.remove('vertical-sidebar-enable');
                (document.documentElement.getAttribute('data-sidebar-size') === 'lg') ? document.documentElement.setAttribute('data-sidebar-size', 'sm') : document.documentElement.setAttribute('data-sidebar-size', 'lg');
            } else if (windowSize <= 767) {
                document.body.classList.add('vertical-sidebar-enable');
                document.documentElement.setAttribute('data-sidebar-size', 'lg');
            }
        }

        //Two column menu
        if (document.documentElement.getAttribute('data-layout') === "twocolumn") {
            document.body.classList.contains('twocolumn-panel') ? document.body.classList.remove('twocolumn-panel') : document.body.classList.add('twocolumn-panel');
        }
    };


    return (
        <React.Fragment>
            <header id="page-topbar" className={headerClass}>
                <div className="layout-width">
                    <div className="navbar-header">
                        <div className="d-flex">

                            <div className="navbar-brand-box horizontal-logo pe-3 ps-4">
                                {/*<a href="" className="logo logo-dark">*/}
                                {/*    <span className="logo-sm">*/}
                                {/*        <img src={logoDark} alt="" height="20" />*/}
                                {/*    </span>*/}
                                {/*    <span className="logo-lg">*/}
                                {/*        <img src={logoDark} alt="" height="28" />*/}
                                {/*    </span>*/}
                                {/*</a>*/}

                                <a href={logoLink} className="logo logo-light">
                                    <span className="logo logo-sm">
                                        <img src={logoLight} alt="" height="22" />
                                    </span>
                                    <span className="logo logo-lg">
                                        <img src={logoLight} alt="" height="28" />
                                    </span>
                                </a>
                            </div>

                          {authUserManager.isAdmin() && <button
                                onClick={toogleMenuBtn}
                                type="button"
                                className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger"
                                id="topnav-hamburger-icon">
                                <span className="hamburger-icon">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </span>
                            </button>
                          }
                        </div>

                        <div className="d-flex align-items-center">
                          {shouldShowQrCode && <QrCodeModal/>}
                          {/*<button*/}
                          {/*  onClick={() => window.location.reload()}*/}
                          {/*  title={t('Page Refresh')}*/}
                          {/*  type="button" className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle light-dark-mode">*/}
                          {/*  <i className='bx bx-refresh fs-22'></i>*/}
                          {/*</button>*/}
                          {/*<LightDark*/}
                          {/*  layoutMode={layoutModeType}*/}
                          {/*  onChangeLayoutMode={onChangeLayoutMode}*/}
                          {/*/>*/}
                          <LanguageDropdown/>
                          <ProfileDropdown/>
                        </div>
                    </div>
                </div>
            </header>
        </React.Fragment>
    );
};

export default Header;
